﻿import config from "../config"
const baseUrl = config.base_url + "z_agricultural_store/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    selectOption: {
        url:  baseUrl + "selectOption",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    save:{
        url:  baseUrl + "save",
        type: "post",
    }
}

